import { ReservationsProvider } from '@context/reservations';
import { PropsWithChildren } from 'react';

export const ReservationsLayout = ({ children }: PropsWithChildren<unknown>) => {
  return <ReservationsProvider>{children}</ReservationsProvider>;
};
